import React, {PropsWithChildren} from 'react';
import * as styles from './styles.module.scss';
import cls from "classnames";

export type PromoDescriptionProps = {
    className?: string,
    color?: string
}

export const PromoDescription = (props: PropsWithChildren<PromoDescriptionProps>) => {
    const {
        className,
        children,
        color = "color-gray"
    } = props;

    return (
        <p className={cls(styles.description, "p-2", color, className)}>
            {children}
        </p>
    )
}
